//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import hot from '../components/footer.vue';
import share from '@/utils/share.js';
import Addorder from '@/utils/addorder.js';
import statistics from '@/utils/statistics.js';
import calender2019 from '@/components/calendar_2019.vue';
import addmyOrderBtn from '../components/MyOrderBtn.vue';
import TheBubble from '@/components/the-bubble';
export default {
  name: 'app',
  components: {
    'hot-footer': hot,
    calender2019,
    addmyOrderBtn,
    TheBubble,
  },
  computed: {
    wx() {
      return this.$store.state.swx;
    },
    float() {
      return this.$store.state.isfloat;
    },
    phone() {
      return this.$store.state.phone;
    },
  },
  data() {
    return {
      footerProp: {
        gid: null,
        type: 1,
      },
      calendarIcon: true, //隐藏和显示日历图标
      calendarShow: false, // 是否显示日历组件
      user_birthDay: {},
      floatmenuProp: {
        isshow: 0,
        homelink: '',
        newOrderBnt: 0,
      },
      marquee_b: {
        count: 0,
        spacing: 0,
        interval: null,
        list: [],
      },
      radioModel: 1, //1为男，0为女
      user_name: '',
      apiData: {},
      show_bottom_btn: false,
    };
  },
  created() {
    const qd = this.$Glb.getAttribute().qd;
    const posid = this.$Glb.getAttribute().posId;
    this.$api.post('v1/Yishengcaiyun/index', { qd: qd, posId: posid, is_new_user: statistics.call(this) }, (res) => {
      this.apiData = res.data;
      this.footerProp.gid = res.data.gid;
      this.floatmenuProp.newOrderBnt = res.data.wx_display;
      // 滚动插件
      this.scroMarquee();
    });
    // 保存 qd 和 posId
    this.saveRoot();
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        var ljcs_btn = document.getElementsByClassName('ljcs_btn')[0];
        var _body = document.getElementsByClassName('yishengcaiyun')[0];
        var _top = ljcs_btn.offsetTop;
        document.addEventListener('scroll', () => {
          var body_top = document.body.scrollTop || document.documentElement.scrollTop;
          if (_top - body_top <= 0) {
            this.show_bottom_btn = true;
          } else {
            this.show_bottom_btn = false;
          }
        });
      }, 1000);
    });
    // 分享
    let sgareUrl = `${window.location.origin}/yscy/wnl/index.html?qd=${window.localStorage.YSCY_ROOT_QD}&posId=${window.localStorage.YSCY_ROOT_POSID}`;
    share(this.$api, {
      wnl: {
        title: '我在万年历看【一生财运】，分享给你，赚钱了请我吃饭呦！',
        desc: '一生财运分析，名师指点财运凶吉年份，秘法开运建议',
        img: 'https://ykdstatic.52dd.cn/index/img/share/yscy_share.jpg',
        url: sgareUrl,
      },
      wechat: {
        title: '同学聚会不敢去？你还没了解你的财运',
        desc: '一生财运分析，名师指点财运凶吉年份，秘法开运建议',
        img: 'https://ykdstatic.52dd.cn/index/img/share/yscy_share.jpg',
        url: sgareUrl,
      },
    });
    // this.setCalendarIcon();
  },
  methods: {
    setCalendarIcon() {
      let timeSelect = document.getElementById('time-select');
      let calendar = document.getElementById('calendar-icon');
      if (timeSelect.offsetWidth > 210) {
        calendar.style.display = 'none';
      } else {
        calendar.style.display = 'block';
      }
    },
    setDate(e) {
      this.calendarShow = false;
      this.user_birthDay = e;
      setTimeout(this.setCalendarIcon, 0);
    },
    saveRoot() {
      window.localStorage.YSCY_ROOT_QD = this.$Glb.getAttribute().qd || '';
      window.localStorage.YSCY_ROOT_POSID = this.$Glb.getAttribute().posId || '';
    },
    // 滚动插件
    scroMarquee() {
      const startM = (cif, sMS) => {
        const sT = (s) => {
          setTimeout(() => {
            if (cif.count == 0) {
              cif.count = cif.count - cif.spacing;
              sT(sMS);
            } else {
              cif.count = 0;
              sT(100);
            }
          }, s);
        };
        sT(100);
      };
      this.$api.post('/v1/ordermsg/index', { gid: this.apiData.gid, cid: this.$Glb.getAttribute().qd }, (res) => {
        this.marquee_b.list = res.data.comment;
        setTimeout(() => {
          this.floatmenuProp.isshow = res.data.isshow;
          this.floatmenuProp.homelink = res.data.homelink;

          this.marquee_b.spacing = this.$refs.marquee_b.scrollHeight + 20;
          this.marquee_b.interval = startM(this.marquee_b, 50000);
        }, 50);
      });
    },
    //跳转到解锁页
    GoTounlock() {
      let userBrithDay = '1990-01-01 00:00';

      if (this.user_birthDay.date) {
        let UDate = this.user_birthDay.date,
          Uhour = `${UDate.hour == '时辰不清楚' ? '00:00' : UDate.hour.split('点')[0] + ':00'}`;

        userBrithDay = `${UDate.cYear}-${UDate.cMonth}-${UDate.cDay} ${Uhour}`;
      }

      if (this.$Glb.validName(this.user_name)) {

        if(!this.$Glb.validTime(userBrithDay)) {
          return
        }
        // 下单接口
        Addorder.call(
          this,
          {
            name: this.user_name,
            birthday: userBrithDay,
            sex: this.radioModel,
            goodsid: this.apiData.gid,
            cid: this.apiData.channel,
            posid: this.apiData.posid,
            nopoint: this.user_birthDay.nopoint === 0 ? 0 : 1,
            sucHref: 'unlock.html',
          },
          function (res) {}
        );
      } else {
        let scrollTopPx = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTopPx > 520) {
          window.scrollTo(0, 0);
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/yscy/index/App.vue